module.exports = __webpack_public_path__ + "static/media/logo_hypeschools_white.14249214.svg";